import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AppDownloadBanner from "./components/AppDownloadBanner";
import ServicesAdvertise from "./components/ServicesAdvertise";
import OurServices from "./components/OurServices";
import Footer from "./components/Footer";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";
import ScrollToTop from "./components/ScrollToTop";
import LoginSignupPage from "./components/LoginSignupPage";
import PartnerRegistrationForm from "./components/PartnerRegistrationForm";

const HomePage = () => (
  <main>
    <section className="relative">
      <div className="relative z-10">
        <HeroSection />
        <AppDownloadBanner />
        <ServicesAdvertise />
        <OurServices />
      </div>
    </section>
  </main>
);

const App = () => {
  return (
    <>
      <ScrollToTop />

      <div className="min-h-screen bg-gray-50">
        <Header />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/login" element={<LoginSignupPage />} />

          {/* Partner Registration */}
          <Route path="/partner-registration" element={<PartnerRegistrationForm />} />
        </Routes>

        <Footer />
      </div>
    </>
  );
};

export default App;
